var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeMml2026(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12033_94163)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_12033_94163",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1462 52.4487C40.3029 52.4488 40.4406 52.5529 40.4831 52.7036L42.3884 59.4897C42.4202 59.6037 42.3923 59.7261 42.3142 59.8149C42.2357 59.904 42.1171 59.9477 41.9997 59.9302L40.5095 59.7095L39.7751 60.8862C39.7072 60.9953 39.585 61.0591 39.4568 61.0513L38.2703 60.979L37.2556 62.355C37.1539 62.4927 36.9667 62.5373 36.8142 62.4595L35.2136 61.6401L33.5691 62.5903C33.4211 62.6757 33.2325 62.6419 33.1238 62.5102L31.8923 61.0151L30.8494 61.103L30.7615 61.1001C30.6755 61.0855 30.5962 61.039 30.5417 60.9682L29.6804 59.8491L28.531 59.855L28.4509 59.8462C28.3727 59.8282 28.3017 59.7831 28.2517 59.7182C28.1854 59.6319 28.1629 59.5188 28.1911 59.4136L29.991 52.7075C30.032 52.5548 30.1708 52.448 30.3288 52.4478L40.1462 52.4487ZM53.241 39.3931L60.0701 41.1353C60.1848 41.1647 60.2773 41.2506 60.3152 41.3628C60.353 41.4752 60.3313 41.6 60.2576 41.6929L59.321 42.8726L59.9734 44.0972C60.0338 44.2105 60.0276 44.3485 59.9568 44.4556L59.3005 45.4468L59.9851 47.0132C60.0537 47.1701 59.9988 47.3545 59.8552 47.4478L58.3454 48.4243V50.3237C58.3454 50.4946 58.2219 50.6411 58.0535 50.6694L56.1433 50.9888L55.698 51.936L55.6511 52.0103C55.5956 52.0774 55.5159 52.1224 55.4275 52.1343L54.0281 52.3208L53.4578 53.3198L53.4099 53.3843C53.3553 53.4429 53.281 53.4817 53.1999 53.4927C53.092 53.507 52.983 53.4701 52.906 53.3931L47.9978 48.481C47.8861 48.3691 47.8633 48.1961 47.9421 48.0591L52.8513 39.5571C52.9298 39.4215 53.0891 39.3543 53.241 39.3931ZM17.3279 39.2261C17.4806 39.1853 17.6422 39.2524 17.7214 39.3892L22.6296 47.8921C22.7077 48.0278 22.6863 48.1989 22.5769 48.311L17.6531 53.354C17.5702 53.4386 17.4499 53.476 17.3337 53.4526C17.2175 53.4291 17.1204 53.3481 17.0769 53.2378L16.5232 51.8364L15.1365 51.7895C15.0082 51.7851 14.892 51.711 14.8347 51.5962L14.3044 50.5317L12.6052 50.3413C12.4352 50.3221 12.3026 50.1831 12.2937 50.0122L12.2029 48.2163L10.5583 47.2661C10.4103 47.1806 10.3452 47.0004 10.405 46.8403L11.0837 45.0269L10.4861 44.1675L10.4451 44.0894C10.4148 44.0079 10.4151 43.9168 10.449 43.8345L10.987 42.5288L10.4079 41.5357L10.3757 41.4614C10.3523 41.3849 10.3555 41.3016 10.3865 41.2261C10.4281 41.1254 10.5146 41.0492 10.6199 41.021L17.3279 39.2261ZM53.3347 16.5474C53.4509 16.5708 53.5479 16.6521 53.5915 16.7623L54.1453 18.1636L55.532 18.2105C55.6604 18.2148 55.7764 18.2898 55.8337 18.4048L56.364 19.4683L58.0632 19.6587C58.2336 19.6778 58.3659 19.8177 58.3747 19.9888L58.4656 21.7847L60.1101 22.7339C60.2582 22.8194 60.3232 22.9996 60.2634 23.1597L59.5857 24.9732L60.1833 25.8326L60.2244 25.9107C60.2547 25.9923 60.2535 26.0841 60.2195 26.1665L59.6814 27.4712L60.2615 28.4644L60.2937 28.5386C60.3171 28.6153 60.3131 28.6993 60.282 28.7749C60.2403 28.8755 60.1537 28.9509 60.0486 28.979L53.3406 30.774C53.1879 30.8146 53.0272 30.7476 52.948 30.6109L48.0388 22.1089C47.9605 21.9732 47.9821 21.8012 48.0915 21.689L53.0154 16.646C53.0982 16.5614 53.2186 16.5242 53.3347 16.5474ZM17.4695 16.5064C17.5774 16.4922 17.6864 16.529 17.7634 16.606L22.6716 21.5181C22.783 21.63 22.806 21.8031 22.7273 21.94L17.8181 30.4419C17.7397 30.5775 17.5802 30.6445 17.4285 30.606L10.5994 28.8638C10.4847 28.8344 10.3922 28.7484 10.3542 28.6363C10.3164 28.5238 10.3381 28.3991 10.4119 28.3062L11.3484 27.1265L10.696 25.9019C10.6356 25.7885 10.6417 25.6506 10.7126 25.5435L11.3689 24.5523L10.6843 22.9859C10.6157 22.8288 10.6704 22.6445 10.8142 22.5513L12.324 21.5747V19.6753C12.324 19.5043 12.4473 19.3579 12.616 19.3296L14.5261 19.0103L14.9714 18.063L15.0183 17.9888C15.0739 17.9216 15.1534 17.8766 15.2419 17.8648L16.6413 17.6783L17.2117 16.6792L17.2595 16.6148C17.3142 16.5561 17.3883 16.5173 17.4695 16.5064ZM37.0994 7.40973C37.2473 7.32429 37.4359 7.35813 37.5447 7.48981L38.7771 8.98395L39.8201 8.89605L39.9079 8.89996C39.9937 8.91458 40.0723 8.96115 40.1267 9.0318L40.988 10.15L42.1384 10.1451L42.2185 10.1539C42.2965 10.1719 42.3668 10.2171 42.4167 10.2818C42.483 10.3681 42.5054 10.4804 42.4773 10.5855L40.6775 17.2925C40.6364 17.4451 40.4985 17.5509 40.3406 17.5513H30.5222C30.3656 17.551 30.2276 17.4463 30.1853 17.2955L28.28 10.5103C28.2481 10.3962 28.276 10.2731 28.3542 10.1841C28.4326 10.0953 28.5515 10.0516 28.6687 10.0689L30.1589 10.2906L30.8933 9.11285C30.9612 9.00408 31.0837 8.94107 31.2117 8.94879L32.3982 9.02105L33.4128 7.64508C33.5145 7.5071 33.7016 7.46263 33.8542 7.54059L35.4548 8.35992L37.0994 7.40973Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.1462 52.4487C40.3029 52.4488 40.4406 52.5529 40.4831 52.7036L42.3884 59.4897C42.4202 59.6037 42.3923 59.7261 42.3142 59.8149C42.2357 59.904 42.1171 59.9477 41.9997 59.9302L40.5095 59.7095L39.7751 60.8862C39.7072 60.9953 39.585 61.0591 39.4568 61.0513L38.2703 60.979L37.2556 62.355C37.1539 62.4927 36.9667 62.5373 36.8142 62.4595L35.2136 61.6401L33.5691 62.5903C33.4211 62.6757 33.2325 62.6419 33.1238 62.5102L31.8923 61.0151L30.8494 61.103L30.7615 61.1001C30.6755 61.0855 30.5962 61.039 30.5417 60.9682L29.6804 59.8491L28.531 59.855L28.4509 59.8462C28.3727 59.8282 28.3017 59.7831 28.2517 59.7182C28.1854 59.6319 28.1629 59.5188 28.1911 59.4136L29.991 52.7075C30.032 52.5548 30.1708 52.448 30.3288 52.4478L40.1462 52.4487ZM53.241 39.3931L60.0701 41.1353C60.1848 41.1647 60.2773 41.2506 60.3152 41.3628C60.353 41.4752 60.3313 41.6 60.2576 41.6929L59.321 42.8726L59.9734 44.0972C60.0338 44.2105 60.0276 44.3485 59.9568 44.4556L59.3005 45.4468L59.9851 47.0132C60.0537 47.1701 59.9988 47.3545 59.8552 47.4478L58.3454 48.4243V50.3237C58.3454 50.4946 58.2219 50.6411 58.0535 50.6694L56.1433 50.9888L55.698 51.936L55.6511 52.0103C55.5956 52.0774 55.5159 52.1224 55.4275 52.1343L54.0281 52.3208L53.4578 53.3198L53.4099 53.3843C53.3553 53.4429 53.281 53.4817 53.1999 53.4927C53.092 53.507 52.983 53.4701 52.906 53.3931L47.9978 48.481C47.8861 48.3691 47.8633 48.1961 47.9421 48.0591L52.8513 39.5571C52.9298 39.4215 53.0891 39.3543 53.241 39.3931ZM17.3279 39.2261C17.4806 39.1853 17.6422 39.2524 17.7214 39.3892L22.6296 47.8921C22.7077 48.0278 22.6863 48.1989 22.5769 48.311L17.6531 53.354C17.5702 53.4386 17.4499 53.476 17.3337 53.4526C17.2175 53.4291 17.1204 53.3481 17.0769 53.2378L16.5232 51.8364L15.1365 51.7895C15.0082 51.7851 14.892 51.711 14.8347 51.5962L14.3044 50.5317L12.6052 50.3413C12.4352 50.3221 12.3026 50.1831 12.2937 50.0122L12.2029 48.2163L10.5583 47.2661C10.4103 47.1806 10.3452 47.0004 10.405 46.8403L11.0837 45.0269L10.4861 44.1675L10.4451 44.0894C10.4148 44.0079 10.4151 43.9168 10.449 43.8345L10.987 42.5288L10.4079 41.5357L10.3757 41.4614C10.3523 41.3849 10.3555 41.3016 10.3865 41.2261C10.4281 41.1254 10.5146 41.0492 10.6199 41.021L17.3279 39.2261ZM53.3347 16.5474C53.4509 16.5708 53.5479 16.6521 53.5915 16.7623L54.1453 18.1636L55.532 18.2105C55.6604 18.2148 55.7764 18.2898 55.8337 18.4048L56.364 19.4683L58.0632 19.6587C58.2336 19.6778 58.3659 19.8177 58.3747 19.9888L58.4656 21.7847L60.1101 22.7339C60.2582 22.8194 60.3232 22.9996 60.2634 23.1597L59.5857 24.9732L60.1833 25.8326L60.2244 25.9107C60.2547 25.9923 60.2535 26.0841 60.2195 26.1665L59.6814 27.4712L60.2615 28.4644L60.2937 28.5386C60.3171 28.6153 60.3131 28.6993 60.282 28.7749C60.2403 28.8755 60.1537 28.9509 60.0486 28.979L53.3406 30.774C53.1879 30.8146 53.0272 30.7476 52.948 30.6109L48.0388 22.1089C47.9605 21.9732 47.9821 21.8012 48.0915 21.689L53.0154 16.646C53.0982 16.5614 53.2186 16.5242 53.3347 16.5474ZM17.4695 16.5064C17.5774 16.4922 17.6864 16.529 17.7634 16.606L22.6716 21.5181C22.783 21.63 22.806 21.8031 22.7273 21.94L17.8181 30.4419C17.7397 30.5775 17.5802 30.6445 17.4285 30.606L10.5994 28.8638C10.4847 28.8344 10.3922 28.7484 10.3542 28.6363C10.3164 28.5238 10.3381 28.3991 10.4119 28.3062L11.3484 27.1265L10.696 25.9019C10.6356 25.7885 10.6417 25.6506 10.7126 25.5435L11.3689 24.5523L10.6843 22.9859C10.6157 22.8288 10.6704 22.6445 10.8142 22.5513L12.324 21.5747V19.6753C12.324 19.5043 12.4473 19.3579 12.616 19.3296L14.5261 19.0103L14.9714 18.063L15.0183 17.9888C15.0739 17.9216 15.1534 17.8766 15.2419 17.8648L16.6413 17.6783L17.2117 16.6792L17.2595 16.6148C17.3142 16.5561 17.3883 16.5173 17.4695 16.5064ZM37.0994 7.40973C37.2473 7.32429 37.4359 7.35813 37.5447 7.48981L38.7771 8.98395L39.8201 8.89605L39.9079 8.89996C39.9937 8.91458 40.0723 8.96115 40.1267 9.0318L40.988 10.15L42.1384 10.1451L42.2185 10.1539C42.2965 10.1719 42.3668 10.2171 42.4167 10.2818C42.483 10.3681 42.5054 10.4804 42.4773 10.5855L40.6775 17.2925C40.6364 17.4451 40.4985 17.5509 40.3406 17.5513H30.5222C30.3656 17.551 30.2276 17.4463 30.1853 17.2955L28.28 10.5103C28.2481 10.3962 28.276 10.2731 28.3542 10.1841C28.4326 10.0953 28.5515 10.0516 28.6687 10.0689L30.1589 10.2906L30.8933 9.11285C30.9612 9.00408 31.0837 8.94107 31.2117 8.94879L32.3982 9.02105L33.4128 7.64508C33.5145 7.5071 33.7016 7.46263 33.8542 7.54059L35.4548 8.35992L37.0994 7.40973Z",
    fill: "#F6C645",
    stroke: "url(#paint0_linear_12033_94163)",
    strokeWidth: 0.8,
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9805 54.5137L36.0801 54.5264L35.1826 61.5352L34.9844 61.5088L35.8818 54.501L35.9805 54.5137ZM33.8379 53.1318L33.9355 53.1562L32.0293 60.8838L31.9316 60.8584L31.8359 60.835L33.7412 53.1084L33.8379 53.1318ZM38.3213 60.7129L38.123 60.7383L37.1641 54.3916L37.2627 54.3789L37.3623 54.3672L38.3213 60.7129ZM40.5225 59.7461L40.3281 59.7939L39.002 54.3301L39.0986 54.3066L39.1963 54.2832L40.5225 59.7461ZM31.6445 53.9277L29.8516 59.5547L29.6592 59.5L31.4531 53.873L31.6445 53.9277ZM53.9033 52.0908L53.7627 52.2334L49.71 47.9375L49.7803 47.8672L49.8506 47.7959L53.9033 52.0908ZM20.499 47.7832L16.5557 51.79L16.4131 51.6504L20.3564 47.6426L20.499 47.7832ZM56.1211 50.8311L56.0527 50.9033L55.9854 50.9766L50.1504 45.5654L50.2178 45.4912L50.2861 45.4189L56.1211 50.8311ZM19.3994 46.1914L19.4619 46.2695L14.5742 50.4287L14.4482 50.2734L19.3359 46.1133L19.3994 46.1914ZM58.2197 48.3887L58.1006 48.5498L52.4053 44.3682L52.4639 44.2871L52.5234 44.207L58.2197 48.3887ZM18.6084 45.1719L18.6504 45.2637L12.2207 48.1953L12.1387 48.0127L18.5674 45.0811L18.6084 45.1719ZM59.0205 45.2441L58.9473 45.4297L52.9316 43.1924L52.9678 43.1006L53.0059 43.0078L59.0205 45.2441ZM18.6533 42.624L18.6836 42.7188L11.1123 45.1719L11.082 45.0762L11.0518 44.9814L18.6221 42.5283L18.6533 42.624ZM59.2422 42.8506L59.1904 43.0439L53.7686 41.5566L53.7939 41.46L53.8213 41.3633L59.2422 42.8506ZM16.793 41.083L16.8213 41.1787L11.0947 42.6211L11.0391 42.4287L16.7666 40.9873L16.793 41.083ZM59.3516 27.7363L53.5762 28.9668L53.5527 28.8701L53.5283 28.7734L59.3037 27.542L59.3516 27.7363ZM16.6387 28.4795L16.6104 28.5752L16.5811 28.6709L11.1973 27.0547L11.2539 26.8633L16.6387 28.4795ZM59.4062 25.0889L59.4326 25.1846L51.7783 27.3584L51.75 27.2627L51.7236 27.166L59.3789 24.9922L59.4062 25.0889ZM17.5146 26.8633L17.4756 26.9551L17.4355 27.0469L11.4756 24.667L11.5537 24.4834L17.5146 26.8633ZM18.0684 25.7012L18.0078 25.7803L17.9463 25.8594L12.3516 21.543L12.4746 21.3848L18.0684 25.7012ZM58.458 22.1162L51.9268 24.8096L51.8877 24.7178L51.8506 24.625L58.3828 21.9307L58.458 22.1162ZM20.3516 24.5576L20.2822 24.6299L20.2119 24.7012L14.5078 19.1514L14.5781 19.0801L14.6475 19.0088L20.3516 24.5576ZM56.2324 19.7715L51.1953 23.75L51.0762 23.5898L56.1123 19.6123L56.2324 19.7715ZM20.8486 22.1973L20.7764 22.2656L20.7041 22.335L16.7549 17.9443L16.8994 17.8057L20.8486 22.1973ZM54.3193 18.3242L50.2324 22.1846L50.1631 22.1123L50.0947 22.0391L54.1816 18.1797L54.3193 18.3242ZM38.6875 9.12402L38.7852 9.14648L37.0137 16.9043L36.915 16.8828L36.8184 16.8604L38.5908 9.10156L38.6875 9.12402ZM40.9834 10.4434L39.2881 16.1006L39.1914 16.0752L39.0947 16.0488L40.79 10.3926L40.9834 10.4434ZM31.7324 15.7734L31.6357 15.7998L31.5391 15.8242L30.1182 10.3857L30.3115 10.334L31.7324 15.7734ZM33.5684 15.6807L33.4697 15.6953L33.3701 15.709L32.3027 9.38086L32.5 9.35254L33.5684 15.6807ZM35.625 8.52637L34.8486 15.5498L34.75 15.5391L34.6504 15.5273L35.4258 8.50391L35.625 8.52637Z",
    fill: "url(#paint1_linear_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3096 2.23285C26.4584 2.24208 26.585 2.34508 26.625 2.48871L35.6699 34.937C35.7128 35.0908 35.6461 35.2545 35.5078 35.3344C35.3696 35.4141 35.1948 35.3907 35.083 35.2768L11.4297 11.1664C11.3246 11.0591 11.3001 10.897 11.3682 10.7631C11.4365 10.6291 11.5827 10.5535 11.7314 10.5756L21.9336 12.0952L25.9648 2.44769C26.0223 2.31014 26.1608 2.22366 26.3096 2.23285Z",
    fill: "url(#paint2_linear_12033_94163)",
    stroke: "url(#paint3_linear_12033_94163)",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.6305,
    cy: 10.4542,
    r: 0.833633,
    fill: "url(#paint4_radial_12033_94163)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.4039,
    cy: 1.27727,
    r: 0.833633,
    fill: "url(#paint5_radial_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3096 67.6824C26.4584 67.6732 26.585 67.5702 26.625 67.4265L35.6699 34.9783C35.7128 34.8245 35.6461 34.6607 35.5078 34.5808C35.3696 34.5012 35.1948 34.5246 35.083 34.6385L11.4297 58.7488C11.3246 58.8561 11.3001 59.0183 11.3682 59.1521C11.4365 59.2861 11.5827 59.3618 11.7314 59.3396L21.9336 57.8201L25.9648 67.4676C26.0223 67.6051 26.1608 67.6916 26.3096 67.6824Z",
    fill: "url(#paint6_linear_12033_94163)",
    stroke: "url(#paint7_linear_12033_94163)",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.833633,
    cy: 0.833633,
    r: 0.833633,
    transform: "matrix(1 0 0 -1 9.79688 60.2947)",
    fill: "url(#paint8_radial_12033_94163)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.833633,
    cy: 0.833633,
    r: 0.833633,
    transform: "matrix(1 0 0 -1 25.5703 69.4716)",
    fill: "url(#paint9_radial_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1411 10.6699C59.2076 10.8034 59.1816 10.9645 59.0773 11.071L35.4987 35.1283C35.387 35.2423 35.2118 35.2664 35.0735 35.1866C34.9354 35.1067 34.8682 34.9436 34.911 34.7899L43.9645 2.25035C44.0049 2.10568 44.133 2.00336 44.283 1.99541C44.4332 1.98757 44.5718 2.07634 44.627 2.21627L48.4122 11.8114L58.7827 10.4788C58.9306 10.4598 59.0747 10.5365 59.1411 10.6699Z",
    fill: "url(#paint10_linear_12033_94163)",
    stroke: "url(#paint11_linear_12033_94163)",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.1792,
    cy: 1.20212,
    r: 0.833633,
    transform: "rotate(60 44.1792 1.20212)",
    fill: "url(#paint12_radial_12033_94163)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.0152,
    cy: 10.2738,
    r: 0.833633,
    transform: "rotate(60 60.0152 10.2738)",
    fill: "url(#paint13_radial_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1411 59.2453C59.2076 59.1118 59.1816 58.9507 59.0773 58.8442L35.4987 34.787C35.387 34.6729 35.2118 34.6488 35.0735 34.7286C34.9354 34.8085 34.8682 34.9716 34.911 35.1253L43.9645 67.6649C44.0049 67.8095 44.133 67.9119 44.283 67.9198C44.4332 67.9277 44.5718 67.8389 44.627 67.699L48.4122 58.1039L58.7827 59.4364C58.9306 59.4554 59.0747 59.3788 59.1411 59.2453Z",
    fill: "url(#paint14_linear_12033_94163)",
    stroke: "url(#paint15_linear_12033_94163)",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.833633,
    cy: 0.833633,
    r: 0.833633,
    transform: "matrix(0.5 -0.866025 -0.866025 -0.5 44.4844 69.8519)",
    fill: "url(#paint16_radial_12033_94163)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.833633,
    cy: 0.833633,
    r: 0.833633,
    transform: "matrix(0.5 -0.866025 -0.866025 -0.5 60.3203 60.7802)",
    fill: "url(#paint17_radial_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8628 26.6159C67.7804 26.4917 67.6279 26.4336 67.4835 26.4707L34.8601 34.8617C34.7054 34.9015 34.597 35.0411 34.5969 35.2008C34.597 35.3604 34.7047 35.5001 34.8592 35.5399L67.5661 43.9691C67.7115 44.0065 67.8642 43.9466 67.9461 43.8207C68.028 43.6945 68.0204 43.5301 67.9268 43.4124L61.5098 35.3368L67.8491 27.0219C67.9395 26.9034 67.9452 26.7402 67.8628 26.6159Z",
    fill: "url(#paint18_linear_12033_94163)",
    stroke: "url(#paint19_linear_12033_94163)",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.833633,
    cy: 0.833633,
    r: 0.833633,
    transform: "matrix(-0.5 -0.866025 -0.866025 0.5 69.7188 44.6102)",
    fill: "url(#paint20_radial_12033_94163)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.833633,
    cy: 0.833633,
    r: 0.833633,
    transform: "matrix(-0.5 -0.866025 -0.866025 0.5 69.7812 26.3616)",
    fill: "url(#paint21_radial_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.48092 43.4718C2.56332 43.5961 2.71581 43.6542 2.86022 43.6171L35.4837 35.2261C35.6383 35.1863 35.7468 35.0466 35.7468 34.887C35.7467 34.7274 35.6391 34.5877 35.4845 34.5479L2.7777 26.1187C2.63222 26.0813 2.47953 26.1411 2.39765 26.267C2.31575 26.3932 2.32332 26.5576 2.41691 26.6754L8.83394 34.751L2.49462 43.0659C2.40422 43.1844 2.39857 43.3476 2.48092 43.4718Z",
    fill: "url(#paint22_linear_12033_94163)",
    stroke: "url(#paint23_linear_12033_94163)",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.833633,
    cy: 0.833633,
    r: 0.833633,
    transform: "matrix(0.5 0.866025 0.866025 -0.5 0.625 25.4775)",
    fill: "url(#paint24_radial_12033_94163)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.833633,
    cy: 0.833633,
    r: 0.833633,
    transform: "matrix(0.5 0.866025 0.866025 -0.5 0.5625 43.7262)",
    fill: "url(#paint25_radial_12033_94163)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.0047,
    cy: 34.3793,
    r: 21.2422,
    fill: "url(#paint26_linear_12033_94163)",
    stroke: "url(#paint27_linear_12033_94163)",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.0051,
    cy: 34.3793,
    r: 18.802,
    fill: "url(#paint28_linear_12033_94163)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.0099,
    cy: 34.3793,
    r: 17.6021,
    fill: "url(#paint29_linear_12033_94163)",
    stroke: "url(#paint30_linear_12033_94163)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12033_94163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0766 46.8159C26.9649 47.9241 28.7109 49.3242 30.5356 50.5864C32.3571 51.8463 34.2324 52.9523 35.3618 53.4741L35.6645 53.6137L35.3989 53.8149C35.2687 53.9137 35.0963 53.9676 34.9125 53.9956C34.7257 54.0239 34.5076 54.0287 34.2719 54.0141C33.8002 53.9849 33.232 53.879 32.6381 53.7211C31.4514 53.4056 30.1292 52.8712 29.2289 52.2758C27.7957 51.3278 26.8587 50.111 26.311 49.0776C26.0375 48.5614 25.8588 48.087 25.7641 47.7104C25.7169 47.5225 25.6897 47.3539 25.683 47.2143C25.677 47.0855 25.6863 46.9442 25.7475 46.8393L25.894 46.5873L26.0766 46.8159ZM46.8774 50.1127C46.7809 50.3614 46.5203 50.6005 46.1938 50.8129C45.8575 51.0316 45.4146 51.2447 44.9028 51.4321C43.878 51.8072 42.552 52.0843 41.1948 52.0717C39.3497 52.0545 37.8525 51.7375 36.8119 51.3715C36.2925 51.1888 35.8816 50.9926 35.5971 50.812C35.4558 50.7222 35.3399 50.6319 35.2563 50.5454C35.1824 50.4689 35.0963 50.3568 35.0961 50.2241V50.0161L35.3041 50.0239C39.6891 50.2017 43.4774 50.5836 46.6459 49.8461L47.0141 49.7592L46.8774 50.1127ZM20.3618 38.9116L20.3852 39.0825C20.8227 42.3288 21.7988 46.1738 23.9145 49.9008L23.9975 50.0473L23.8676 50.1547C23.7236 50.273 23.5432 50.2538 23.4028 50.2055C23.2579 50.1556 23.1006 50.0574 22.9409 49.934C22.6184 49.6849 22.239 49.2937 21.8588 48.8237C21.0984 47.8835 20.3005 46.5918 19.9018 45.4038C19.3828 43.8569 19.2988 42.2684 19.3979 41.0678C19.4474 40.468 19.5437 39.9578 19.6577 39.5932C19.7141 39.4125 19.7779 39.2581 19.8481 39.145C19.8831 39.0886 19.9248 39.033 19.975 38.9907C20.025 38.9487 20.099 38.9069 20.1909 38.9086L20.3618 38.9116ZM23.7397 49.9995C23.7077 50.0257 23.6689 50.039 23.6235 50.0415C23.6462 50.0402 23.6675 50.0378 23.6869 50.0307C23.7065 50.0236 23.7246 50.0136 23.7407 50.0004L23.7397 49.9995ZM53.9282 40.1176C54.0022 40.2544 54.013 40.4157 53.9936 40.5747C53.9739 40.7359 53.9207 40.9154 53.8442 41.1039C53.6909 41.4814 53.432 41.9268 53.1039 42.3979C52.4466 43.3418 51.4911 44.4176 50.4809 45.3071C49.4456 46.2185 48.0722 46.8147 46.9243 47.1498C46.3493 47.3177 45.824 47.4218 45.4184 47.4672C45.2162 47.4898 45.0374 47.4986 44.8959 47.4916C44.8255 47.4881 44.7589 47.4797 44.7006 47.4663C44.6465 47.4537 44.5791 47.432 44.5239 47.3872L44.2973 47.2036L44.5512 47.0581C45.7529 46.3733 47.8443 44.9004 49.727 43.4565C50.6668 42.7357 51.551 42.0241 52.2436 41.4262C52.5899 41.1272 52.8876 40.8568 53.1186 40.6293C53.3525 40.399 53.5085 40.2215 53.5834 40.1049L53.766 39.8198L53.9282 40.1176ZM50.3491 45.1567C50.2862 45.212 50.2221 45.2668 50.1567 45.3198L50.3491 45.1567L50.7211 44.8188C50.5985 44.9338 50.4738 45.0468 50.3491 45.1567ZM20.1977 29.5463C19.6743 30.7853 18.9203 33.1545 18.2651 35.4155C17.6093 37.6784 17.0582 39.8096 16.934 40.5707L16.8852 40.8745L16.6274 40.7055C16.5293 40.641 16.4631 40.5249 16.4164 40.4184C16.3654 40.302 16.3191 40.1542 16.2787 39.9848C16.1977 39.6449 16.1345 39.194 16.102 38.6743C16.037 37.6344 16.0947 36.2969 16.4018 34.9789C16.7833 33.3419 17.524 31.9291 18.2328 30.9252C18.5872 30.4235 18.937 30.0201 19.2338 29.7397C19.3819 29.5999 19.5204 29.4867 19.643 29.4077C19.7562 29.3347 19.8872 29.2691 20.0121 29.269H20.3139L20.1977 29.5463ZM53.6782 27.6264C53.7856 27.7038 53.8724 27.824 53.9438 27.9565C54.0168 28.092 54.0826 28.2577 54.141 28.4428C54.2581 28.8137 54.3523 29.2844 54.4145 29.7993C54.5387 30.8281 54.5409 32.0657 54.3373 33.1049C54.0412 34.6162 53.4355 36.2956 52.8481 37.6206C52.5541 38.2836 52.2613 38.8619 52.0131 39.2895C51.8894 39.5026 51.7744 39.6824 51.6733 39.8168C51.6228 39.8839 51.573 39.9432 51.5258 39.9907C51.4814 40.0353 51.4262 40.083 51.3637 40.1108L51.0688 40.2416L51.0834 39.9184C51.188 37.6284 51.7203 34.9856 52.2436 32.7211C52.5052 31.5893 52.7659 30.5442 52.9701 29.6879C53.1761 28.8246 53.3232 28.1604 53.3627 27.769L53.3969 27.4243L53.6782 27.6264ZM54.2055 32.6772L54.2504 32.3002V32.2944C54.2378 32.4236 54.2233 32.5515 54.2055 32.6772ZM46.4233 18.144C46.5525 18.1442 46.6886 18.1924 46.8188 18.2592C46.9528 18.3281 47.099 18.4264 47.2504 18.5473C47.5537 18.7894 47.8971 19.1346 48.2446 19.5541C48.9398 20.3936 49.6678 21.5498 50.141 22.8207C50.6155 24.0952 50.8151 25.618 50.8442 26.8198C50.8587 27.4208 50.8308 27.9504 50.77 28.3344C50.7398 28.5243 50.6999 28.6899 50.6479 28.8129C50.6221 28.8739 50.5889 28.9367 50.5434 28.9868C50.4972 29.0375 50.4223 29.0904 50.3217 29.0922L50.1567 29.0961L50.1225 28.934C49.768 27.2395 48.908 24.907 48.0776 22.8432C47.6634 21.8139 47.2584 20.8547 46.9291 20.0795C46.6013 19.3078 46.3451 18.7107 46.2348 18.4145L46.1342 18.144H46.4233ZM25.2983 21.268C25.4267 21.2876 25.5566 21.3239 25.6489 21.3979L25.9057 21.6049L25.6039 21.7368C24.3292 22.2945 22.5262 23.5812 20.8276 24.977C19.1318 26.3705 17.561 27.8547 16.7534 28.7915L16.6186 28.9487L16.4672 28.8071C16.3991 28.7437 16.3767 28.6615 16.3705 28.601C16.3642 28.5385 16.3713 28.4721 16.3832 28.4086C16.4073 28.2809 16.4607 28.1245 16.5336 27.9526C16.6807 27.6062 16.9228 27.1584 17.2338 26.6694C17.8563 25.6908 18.769 24.5213 19.7817 23.6225C21.054 22.4933 22.381 21.8428 23.4457 21.517C23.9772 21.3545 24.4474 21.2719 24.8159 21.2514C24.9998 21.2412 25.1632 21.2474 25.2983 21.268ZM34.6264 14.1752C34.7908 14.1675 34.9977 14.1802 35.2328 14.2104C35.7051 14.2712 36.3169 14.4031 36.9799 14.5961C38.3026 14.9813 39.8618 15.617 40.9545 16.435C42.1923 17.3618 43.0729 18.3071 43.645 19.1264C43.9308 19.5359 44.1412 19.9167 44.2807 20.2495C44.419 20.5792 44.4926 20.8749 44.4926 21.1108V21.5141L44.1713 21.269C40.9489 18.8035 37.2371 16.1482 34.2494 14.6313L34.0063 14.5073L34.1977 14.3129C34.2569 14.2528 34.3348 14.2224 34.3989 14.2055C34.4667 14.1877 34.5445 14.1791 34.6264 14.1752ZM28.9623 16.4907C31.1306 16.4907 32.6409 16.7986 33.6157 17.1596C34.1022 17.3398 34.4603 17.5349 34.7006 17.7153C34.8203 17.8052 34.9156 17.8954 34.9828 17.9819C35.0453 18.0622 35.1039 18.1653 35.1039 18.2778V18.4975L34.8852 18.477C31.7041 18.1731 27.0661 18.1938 23.5483 18.7602L23.3159 18.7973V18.5629C23.3159 18.4812 23.3526 18.4135 23.3823 18.3696C23.4147 18.3217 23.4577 18.2746 23.5043 18.2309C23.5982 18.143 23.7288 18.0463 23.8852 17.9467C24.2 17.7464 24.6429 17.5186 25.1655 17.3041C26.2095 16.8758 27.5976 16.4907 28.9623 16.4907ZM34.8364 18.1225L34.8246 18.104C34.8097 18.0848 34.7903 18.0669 34.7709 18.0463C34.7962 18.0732 34.8181 18.0985 34.8364 18.1225Z",
    fill: "url(#paint31_linear_12033_94163)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_12033_94163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1523 53.0811C38.3057 53.8793 32.1488 55.8595 27.7864 56.2466L27.5358 56.2701L27.6133 56.5087C27.6701 56.6828 27.8147 56.8126 27.9784 56.9096C28.1459 57.0088 28.3624 57.0899 28.6098 57.1569C29.1059 57.2912 29.7637 57.3758 30.5008 57.4058C31.9758 57.4657 33.8057 57.3106 35.3718 56.8781C36.4445 56.5818 38.0144 55.8246 39.2699 55.0945C39.8989 54.7286 40.4586 54.3639 40.8423 54.0611C41.0322 53.9112 41.1896 53.7689 41.2898 53.6431C41.3388 53.5814 41.3846 53.5112 41.4082 53.4363C41.4329 53.3574 41.4383 53.2486 41.366 53.1533L41.2845 53.0438L41.1523 53.0811ZM34.7283 56.8326C34.4356 56.8983 34.1365 56.9545 33.835 57.0024C34.1367 56.9542 34.4358 56.8974 34.7286 56.8317L34.7283 56.8326ZM16.0683 47.9924C16.0188 48.0835 16.0285 48.1806 16.0455 48.2484C16.0634 48.3195 16.098 48.3931 16.1385 48.4634C16.2201 48.6049 16.3477 48.7715 16.5061 48.9511C16.8251 49.3128 17.2916 49.7553 17.8274 50.2056C18.8955 51.103 20.2729 52.0566 21.3565 52.4615C22.684 52.9574 24.4376 53.3593 25.9058 53.5671C26.64 53.671 27.3108 53.7276 27.8246 53.7223C28.0804 53.7197 28.3055 53.7008 28.4835 53.6625C28.5726 53.6433 28.6568 53.6182 28.7288 53.5832C28.7995 53.5488 28.8724 53.4991 28.9224 53.4247L29.0761 53.1941L28.8093 53.1198C26.8082 52.5599 24.1598 51.5454 21.7736 50.5252C19.3851 49.504 17.2756 48.4839 16.3485 47.9172L16.1697 47.8076L16.0683 47.9924ZM51.1109 46.0709C50.0386 48.0127 48.2986 50.0233 46.5687 51.8458C44.85 53.6566 43.1252 55.2965 42.1337 56.4585L41.9348 56.6939L42.2302 56.7813C42.5356 56.8708 42.9032 56.8182 43.2962 56.6796C43.6935 56.5394 44.142 56.3013 44.6238 55.9825C45.5885 55.344 46.7115 54.3673 47.8604 53.1551C48.7261 52.2415 49.7263 50.6292 50.4587 49.1948C50.8258 48.4757 51.1302 47.7929 51.3187 47.2561C51.4126 46.9889 51.4796 46.7503 51.5106 46.5586C51.5261 46.4632 51.5331 46.3715 51.5275 46.2902C51.5222 46.2128 51.5033 46.118 51.4422 46.0416L51.2562 45.8084L51.1109 46.0709ZM42.3767 56.6093L42.2865 56.5889C42.3165 56.5977 42.3477 56.6038 42.3798 56.6094C42.3788 56.6092 42.3777 56.6095 42.3767 56.6093ZM11.5144 33.9448C11.4748 34.0098 11.4551 34.0884 11.4437 34.1601C11.4318 34.2352 11.4256 34.3215 11.4251 34.4155C11.4243 34.6049 11.444 34.8426 11.4791 35.1117C11.5495 35.651 11.6867 36.3392 11.8788 37.0748C12.2619 38.5412 12.8678 40.2284 13.5975 41.3248C14.6597 42.9205 15.8349 44.1364 16.8375 44.9305C17.3381 45.327 17.7997 45.622 18.1868 45.8055C18.3802 45.8971 18.5599 45.9631 18.7191 45.9992C18.875 46.0346 19.03 46.0449 19.1638 46.0068L19.4766 45.9182L19.2555 45.6788C15.774 41.9163 13.2089 36.4887 11.862 33.9544L11.6967 33.6446L11.5144 33.9448ZM13.4885 40.7615C13.5355 40.8458 13.5835 40.9275 13.6319 41.0067L13.6316 41.0076C13.5831 40.9282 13.5354 40.8461 13.4885 40.7615ZM48.3703 52.231L48.3694 52.2306L48.3703 52.231ZM54.8034 34.5401C55.0313 38.6151 54.9162 44.0574 53.8307 48.1493L53.7162 48.5801L54.1137 48.3805C54.3597 48.2566 54.626 47.9532 54.8822 47.56C55.1448 47.1567 55.4175 46.6258 55.6674 46.007C56.167 44.7699 56.5825 43.1621 56.6393 41.4759C56.7297 38.7913 56.6028 37.1993 56.3287 36.1885C56.1908 35.68 56.0131 35.3129 55.8042 35.0263C55.5952 34.7396 55.3599 34.5417 55.1211 34.3673L54.7812 34.1182L54.8034 34.5401ZM16.2208 20.5441C16.1487 20.5441 16.0839 20.5702 16.0343 20.5975C15.983 20.6257 15.9332 20.6642 15.886 20.7067C15.7914 20.7921 15.6893 20.9113 15.5848 21.0562C15.3748 21.3474 15.1369 21.7645 14.9031 22.2801C14.4346 23.313 13.9734 24.7618 13.7865 26.4342C13.4863 29.1214 13.703 31.0529 14.0414 32.3439C14.2106 32.9891 14.4111 33.4757 14.5931 33.8169C14.6839 33.9872 14.7706 34.1237 14.8487 34.2259C14.9225 34.3225 15.0004 34.4048 15.0753 34.4496L15.4132 34.6515L15.3781 34.2602C15.0882 31.0718 15.4168 24.7272 16.4145 20.7935L16.4774 20.5444L16.2208 20.5441ZM27.9228 11.7915C27.85 11.7735 27.7727 11.7836 27.7121 11.796C27.6462 11.8095 27.5722 11.8324 27.4932 11.8618C27.334 11.921 27.1358 12.0128 26.9117 12.1311C26.4621 12.3685 25.8878 12.7213 25.2623 13.1539C24.0124 14.0183 22.5415 15.2156 21.4426 16.4902C20.5546 17.5203 19.8357 18.8639 19.38 20.0408C19.1522 20.6294 18.9873 21.1822 18.9016 21.6397C18.8589 21.8684 18.835 22.0787 18.8337 22.2587C18.8324 22.4343 18.8524 22.6 18.9115 22.7314L19.0845 23.1133L19.2727 22.7406C21.1185 19.0816 25.1123 14.8506 28.0122 12.1315L28.2799 11.88L27.9228 11.7915ZM56.5473 26.7834C54.8613 23.7863 52.5604 22.6942 51.3148 22.4178L50.8172 22.3077L51.1066 22.7265C51.6961 23.5809 52.354 24.4805 53.028 25.4048C53.7029 26.3304 54.3958 27.2823 55.0566 28.2431C56.3797 30.1668 57.5687 32.1179 58.2413 33.9601L58.437 34.4949L58.6188 33.9553C58.7297 33.6259 58.7426 33.1793 58.6869 32.6716C58.6306 32.1588 58.5024 31.5623 58.3148 30.9212C57.9395 29.6387 57.3219 28.1605 56.5473 26.7834ZM42.0736 11.5325C41.8599 11.4405 41.5786 11.3688 41.2583 11.3135C40.6152 11.2026 39.7721 11.1505 38.8871 11.1492C38.0008 11.1478 37.0647 11.1978 36.2334 11.2932C35.4065 11.3881 34.6662 11.5291 34.1828 11.718C32.3785 12.423 31.0438 13.2333 30.1572 13.9133C29.7143 14.2531 29.3801 14.5625 29.1552 14.8121C29.0432 14.9364 28.9548 15.0495 28.8935 15.1465C28.8631 15.1946 28.8377 15.2424 28.8188 15.2879C28.801 15.3308 28.7835 15.3858 28.7834 15.4442L28.7828 15.7194L29.0446 15.6346C32.0962 14.6454 40.2174 12.5222 42.3729 12.2084L42.6011 12.1749L42.5363 11.9532C42.4753 11.7473 42.2734 11.6184 42.0736 11.5325ZM51.7659 22.7507C51.5874 22.6908 51.422 22.6454 51.2732 22.6123L51.2713 22.6116C51.346 22.6282 51.4247 22.6479 51.5072 22.6709C51.5896 22.6939 51.6756 22.7204 51.765 22.7504L51.7659 22.7507ZM47.4221 15.269C45.7984 14.7516 44.2337 14.6153 43.0707 14.6772C42.4903 14.7081 42.0017 14.7886 41.6524 14.9002C41.479 14.9556 41.3288 15.0228 41.2178 15.1023C41.1133 15.1771 41.0009 15.2952 41.0007 15.4596L41.0015 15.6162L41.1528 15.654C44.4112 16.4525 50.4338 18.6493 53.817 20.5555L54.1168 20.7243L54.1155 20.3811C54.1147 20.2094 54.0432 20.0212 53.94 19.8358C53.8343 19.6459 53.683 19.4371 53.4971 19.218C53.1245 18.7789 52.5981 18.2814 51.9743 17.7859C50.7275 16.7954 49.0683 15.7936 47.4221 15.269ZM48.2715 15.797C48.351 15.8304 48.4302 15.8653 48.5094 15.9005C48.3299 15.8207 48.1496 15.7449 47.9687 15.6748L48.2715 15.797ZM47.0627 15.3691C47.038 15.3619 47.0131 15.3551 46.9884 15.3481C47.0131 15.3551 47.0383 15.361 47.0631 15.3682L47.362 15.4601L47.0627 15.3691Z",
    fill: "url(#paint32_linear_12033_94163)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 35.2539,
    cy: 35.9549,
    r: 13.1602,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.3146,
    cy: 35.984,
    r: 12.4943,
    stroke: "#DDB06D",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeDasharray: "0.01 0.8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_12033_94163)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7578 7.66849C35.0016 7.92739 35.4492 8.31071 36.0723 8.64505C36.7897 9.02996 37.5977 9.02982 37.8906 9.02982V11.9771C37.8905 14.3996 35.949 15.2817 34.7578 16.0611C33.5667 15.2817 31.6252 14.3998 31.625 11.9771V9.02982C31.9183 9.02982 32.7253 9.02971 33.4424 8.64505C34.0656 8.31062 34.514 7.9274 34.7578 7.66849Z",
    fill: "url(#paint33_linear_12033_94163)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-29-outside-2_12033_94163",
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 7.34564,
    width: 7,
    height: 9,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 31,
    y: 7.34564,
    width: 7,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7588 8.34564C35.0029 8.6045 35.6912 8.99067 36.0957 9.15619C36.6077 9.3656 37.2206 9.51445 37.5137 9.51459C37.5137 10.0488 37.5166 10.9104 37.5166 11.9853C37.5166 13.6623 35.7174 14.9662 34.7588 15.3837C33.8004 14.9666 32 13.6628 32 11.9853C32 10.9104 32.0029 10.0488 32.0029 9.51459C32.2962 9.51439 32.909 9.36562 33.4209 9.15619C33.8256 8.99055 34.5151 8.60447 34.7588 8.34564Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7588 8.34564C35.0029 8.6045 35.6912 8.99067 36.0957 9.15619C36.6077 9.3656 37.2206 9.51445 37.5137 9.51459C37.5137 10.0488 37.5166 10.9104 37.5166 11.9853C37.5166 13.6623 35.7174 14.9662 34.7588 15.3837C33.8004 14.9666 32 13.6628 32 11.9853C32 10.9104 32.0029 10.0488 32.0029 9.51459C32.2962 9.51439 32.909 9.36562 33.4209 9.15619C33.8256 8.99055 34.5151 8.60447 34.7588 8.34564Z",
    fill: "url(#paint34_linear_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7588 8.34564L34.8679 8.24274L34.7587 8.12691L34.6496 8.24281L34.7588 8.34564ZM36.0957 9.15619L36.0389 9.29502L36.0389 9.29502L36.0957 9.15619ZM37.5137 9.51459L37.6637 9.51459L37.6637 9.36466L37.5137 9.36459L37.5137 9.51459ZM37.5166 11.9853L37.6666 11.9853V11.9853H37.5166ZM34.7588 15.3837L34.6989 15.5213L34.7588 15.5473L34.8187 15.5213L34.7588 15.3837ZM32 11.9853H31.85V11.9853L32 11.9853ZM32.0029 9.51459L32.0028 9.36459L31.8529 9.36469L31.8529 9.51459L32.0029 9.51459ZM33.4209 9.15619L33.4777 9.29502L33.4777 9.29501L33.4209 9.15619ZM34.7588 8.34564L34.6497 8.44855C34.7874 8.5946 35.0366 8.76485 35.2908 8.91506C35.5487 9.06744 35.8285 9.2089 36.0389 9.29502L36.0957 9.15619L36.1525 9.01736C35.9585 8.93796 35.6918 8.80358 35.4434 8.65678C35.1913 8.50781 34.9743 8.35555 34.8679 8.24274L34.7588 8.34564ZM36.0957 9.15619L36.0389 9.29502C36.3022 9.4027 36.5903 9.49442 36.8504 9.5594C37.1077 9.62365 37.3484 9.66451 37.5136 9.66459L37.5137 9.51459L37.5137 9.36459C37.3859 9.36453 37.1736 9.3309 36.9231 9.26834C36.6756 9.20651 36.4012 9.1191 36.1525 9.01735L36.0957 9.15619ZM37.5137 9.51459L37.3637 9.51459C37.3637 9.78186 37.3644 10.131 37.3651 10.5475C37.3659 10.964 37.3666 11.448 37.3666 11.9853H37.5166H37.6666C37.6666 11.4477 37.6659 10.9635 37.6651 10.5469C37.6644 10.1303 37.6637 9.78151 37.6637 9.51459L37.5137 9.51459ZM37.5166 11.9853L37.3666 11.9853C37.3666 12.769 36.9455 13.4787 36.3894 14.0525C35.8344 14.6252 35.1616 15.0447 34.6989 15.2462L34.7588 15.3837L34.8187 15.5213C35.3146 15.3053 36.0206 14.8641 36.6049 14.2612C37.1881 13.6594 37.6666 12.8786 37.6666 11.9853L37.5166 11.9853ZM34.7588 15.3837L34.8187 15.2462C34.3561 15.0448 33.683 14.6254 33.1277 14.0527C32.5714 13.479 32.15 12.7692 32.15 11.9853L32 11.9853L31.85 11.9853C31.85 12.8789 32.3288 13.6597 32.9123 14.2615C33.4968 14.8644 34.2031 15.3054 34.6989 15.5213L34.7588 15.3837ZM32 11.9853H32.15C32.15 11.448 32.1507 10.964 32.1515 10.5475C32.1522 10.131 32.1529 9.78186 32.1529 9.51459L32.0029 9.51459L31.8529 9.51459C31.8529 9.78151 31.8522 10.1303 31.8515 10.5469C31.8507 10.9635 31.85 11.4477 31.85 11.9853H32ZM32.0029 9.51459L32.003 9.66459C32.1683 9.66448 32.409 9.62362 32.6662 9.55938C32.9264 9.49441 33.2145 9.40271 33.4777 9.29502L33.4209 9.15619L33.3641 9.01736C33.1154 9.11911 32.8411 9.2065 32.5935 9.26832C32.3431 9.33087 32.1308 9.3645 32.0028 9.36459L32.0029 9.51459ZM33.4209 9.15619L33.4777 9.29501C33.6882 9.20886 33.9683 9.06741 34.2265 8.91504C34.4809 8.76487 34.7304 8.5946 34.868 8.44847L34.7588 8.34564L34.6496 8.24281C34.5435 8.3555 34.3264 8.5077 34.074 8.65668C33.8253 8.80347 33.5583 8.93788 33.3641 9.01736L33.4209 9.15619Z",
    fill: "#917F3E",
    mask: "url(#path-29-outside-2_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7598 8.57449C34.9797 8.81743 35.6019 9.17992 35.9668 9.33524C36.4286 9.53173 36.981 9.67117 37.2451 9.67117C37.2451 10.1725 37.2471 10.9817 37.2471 11.9905C37.2467 13.5642 35.6239 14.7875 34.7598 15.179C33.8956 14.7875 32.2738 13.5642 32.2734 11.9905C32.2734 10.9817 32.2754 10.1725 32.2754 9.67117C32.5396 9.67107 33.092 9.53173 33.5537 9.33524C33.9185 9.1799 34.5398 8.81739 34.7598 8.57449Z",
    fill: "url(#paint35_linear_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5723 10.3184L34.5267 10.2923L34.4812 10.3188L33.2171 11.0563C33.1736 11.0817 33.1589 11.1375 33.1843 11.1809C33.1949 11.1991 33.2108 11.2123 33.229 11.2196C33.2542 11.2297 33.2837 11.2285 33.3089 11.2137L34.5276 10.5027L35.3197 10.9549C35.3405 10.9668 35.3638 10.9696 35.3853 10.9646C35.4092 10.9591 35.4309 10.944 35.444 10.921C35.4588 10.8951 35.4595 10.8651 35.4486 10.8397C35.441 10.8222 35.4279 10.8069 35.4101 10.7967L35.1732 10.6614C35.1756 10.6528 35.1768 10.6436 35.1768 10.6342V10.4551C35.1768 10.3989 35.1313 10.3534 35.0752 10.3534C35.019 10.3534 34.9735 10.3989 34.9735 10.4551V10.5474L34.5723 10.3184Z",
    fill: "url(#paint36_linear_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3956 11.3932H33.1328V11.7082H33.5817V13.4062H33.9622V11.7082H34.3956V11.3932Z",
    fill: "url(#paint37_linear_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8534 11.0593L35.5912 10.9166C35.5655 10.9637 35.4819 11.0579 35.3526 11.0579H34.5133V11.517C34.5482 11.5158 34.6437 11.5225 34.7465 11.5592C34.8751 11.6052 34.9908 11.7558 34.9908 11.9574C34.9908 12.1591 34.9412 12.2131 34.9026 12.2718C34.8641 12.3306 34.7189 12.4316 34.6345 12.4316H34.4453V12.5473C34.471 12.5436 34.5345 12.5385 34.583 12.5473C34.6436 12.5583 34.6785 12.6428 34.7189 12.7071C34.7593 12.7714 35.033 13.1681 35.0899 13.2287C35.1468 13.2893 35.2883 13.3921 35.3948 13.4233C35.48 13.4483 35.6299 13.4338 35.6941 13.4233C35.6592 13.408 35.5788 13.3697 35.5362 13.3389C35.4829 13.3003 35.4407 13.2525 35.3176 13.0964C35.2192 12.9716 34.9889 12.6146 34.8861 12.4518C34.9105 12.4408 34.9856 12.4008 35.0899 12.3288C35.2203 12.2388 35.2823 12.0561 35.2823 11.9574C35.2823 11.8588 35.2849 11.7082 35.1551 11.5733C35.0513 11.4653 34.809 11.421 34.7009 11.4123V11.2255H35.8066C35.856 11.2255 35.8845 11.1969 35.8845 11.1424C35.8845 11.0988 35.8637 11.0688 35.8534 11.0593Z",
    fill: "url(#paint38_linear_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2249 11.5198V11.4074C35.2694 11.4074 35.3854 11.4098 35.4936 11.4197C35.6288 11.432 35.7956 11.5303 35.8606 11.59C35.9256 11.6497 35.9747 11.8183 35.9747 11.9711C35.9747 12.1239 35.9185 12.1976 35.8079 12.303C35.7194 12.3873 35.6071 12.4282 35.562 12.4382C35.5878 12.4809 35.6527 12.5836 35.706 12.6524C35.7728 12.7385 36.0801 13.1968 36.189 13.3109C36.2761 13.4023 36.3611 13.4286 36.3927 13.4304C36.3078 13.4263 36.1226 13.4163 36.0608 13.4093C35.9835 13.4005 35.8518 13.318 35.7675 13.2056C35.7001 13.1157 35.524 12.8637 35.4444 12.749C35.397 12.6782 35.2909 12.5365 35.246 12.5365H35.1406V12.4382C35.1939 12.4382 35.331 12.4284 35.4532 12.389C35.606 12.3398 35.6762 12.173 35.6762 11.9711C35.6762 11.7691 35.6148 11.662 35.4936 11.59C35.3967 11.5324 35.2741 11.5192 35.2249 11.5198Z",
    fill: "url(#paint39_linear_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7603 9.0098L34.8601 9.24985L35.1193 9.27062L34.9218 9.43976L34.9822 9.69265L34.7603 9.55713L34.5384 9.69265L34.5987 9.43976L34.4013 9.27062L34.6604 9.24985L34.7603 9.0098Z",
    fill: "#F2E5A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7604 13.7066L34.9016 14.046L35.2681 14.0754L34.9888 14.3146L35.0741 14.6722L34.7604 14.4806L34.4466 14.6722L34.5319 14.3146L34.2527 14.0754L34.6192 14.046L34.7604 13.7066Z",
    fill: "#F2E5A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5831 13.4946L33.6485 13.6518L33.8182 13.6654L33.6889 13.7762L33.7284 13.9418L33.5831 13.853L33.4378 13.9418L33.4773 13.7762L33.348 13.6654L33.5177 13.6518L33.5831 13.4946Z",
    fill: "#F2E5A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9347 13.4946L36.0001 13.6518L36.1698 13.6654L36.0405 13.7762L36.08 13.9418L35.9347 13.853L35.7894 13.9418L35.8289 13.7762L35.6996 13.6654L35.8693 13.6518L35.9347 13.4946Z",
    fill: "#F2E5A0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.627 35.8616L31.21 33.0764H33.6523L31.6025 38.7239H29.6377L30.7041 35.5813L27.8975 38.7239H27.252L26.6621 35.5813L25.4912 38.7239H23.4062L25.4912 33.0764H28.1104L28.627 35.8616ZM36.8506 33.0764L37.3682 35.8616L39.9502 33.0764H42.3926L40.3438 38.7239H38.3779L39.4453 35.5813L36.6377 38.7239H35.9922L35.4033 35.5813L34.2314 38.7239H32.1465L34.2314 33.0764H36.8506ZM43.4336 37.1331H46.8359L45.9043 38.6048H40.8008L43.1201 33.0764H45.1689L43.4336 37.1331Z",
    fill: "url(#paint40_linear_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2936 40.1107L37.0799 40.4888H36.3399C35.9619 40.4888 35.7856 41.2328 36.1068 41.2328H36.9256L36.6841 41.6382H35.9685C34.9956 41.6382 35.3917 40.1107 36.1244 40.1107H37.2936Z",
    fill: "url(#paint41_linear_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6068 40.4123L32.8541 40.067L31.505 40.067C30.8871 40.067 30.7685 41.0171 31.3837 41.0171H31.9307C32.1073 41.0171 32.0818 41.2819 31.946 41.2819H30.9273L30.6328 41.6349H32.0725C32.5783 41.6349 32.5403 40.6938 32.1447 40.6938H31.5323C31.3549 40.6938 31.4273 40.4123 31.5623 40.4123H32.6068Z",
    fill: "url(#paint42_linear_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9818 40.4123L43.2291 40.067L41.88 40.067C41.2621 40.067 41.1435 41.0171 41.7587 41.0171H42.3057C42.4823 41.0171 42.4568 41.2819 42.321 41.2819H41.3023L41.0078 41.6349H42.4475C42.9533 41.6349 42.9153 40.6938 42.5197 40.6938H41.9073C41.7299 40.6938 41.8023 40.4123 41.9373 40.4123H42.9818Z",
    fill: "url(#paint43_linear_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9427 40.4123L45.19 40.067L43.8409 40.067C43.2231 40.067 43.1045 41.0171 43.7196 41.0171H44.2667C44.4432 41.0171 44.4177 41.2819 44.282 41.2819H43.2632L42.9688 41.6349H44.4085C44.9142 41.6349 44.8762 40.6938 44.4806 40.6938H43.8682C43.6908 40.6938 43.7632 40.4123 43.8982 40.4123H44.9427Z",
    fill: "url(#paint44_linear_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0444 40.0445H25.3463L24.7188 41.655H25.2639L25.4753 41.0611H26.1698L26.512 40.6887H25.8376L25.5658 40.89L25.747 40.4572H26.7134L27.0444 40.0445Z",
    fill: "url(#paint45_linear_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0178 40.5129L27.2449 40.0445H28.7679L28.5666 40.5129H28.0542L27.8402 41.1598H28.3449L28.1724 41.655H26.4922L26.7714 41.1598H27.2856L27.5013 40.5129H27.0178Z",
    fill: "url(#paint46_linear_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0256 41.6404H28.5L29.0812 40.0564H29.5278C30.3711 40.0564 30.6918 40.0521 30.6918 40.5591C30.6918 41.0046 30.4003 41.0127 29.866 41.0127L30.4501 41.6404H29.8295L29.2732 41.0367L29.5278 40.6949H30.1137C30.2559 40.6949 30.2703 40.4043 30.1137 40.4043H29.435L29.0256 41.6404Z",
    fill: "url(#paint47_linear_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8906 40.5129L33.1252 40.0445H34.6985L34.4521 40.5129H34.025L33.6066 41.655H33.0327L33.4539 40.5129H32.8906Z",
    fill: "url(#paint48_linear_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8677 41.6349L40.135 41.23H39.5159L40.0841 40.5073L40.2289 41.6349H40.7514L40.4684 40.067H39.8677L38.6406 41.6349H39.8677Z",
    fill: "url(#paint49_linear_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1779 40.0868H37.6292L37.0078 41.6457H38.3749L38.6246 41.2308H37.7133L38.1779 40.0868Z",
    fill: "url(#paint50_linear_12033_94163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3789 25.499C35.5579 25.499 35.7031 25.6442 35.7031 25.8232C35.7031 25.9846 35.585 26.1167 35.4307 26.1416L35.7598 26.6963L36.1641 26.4277C36.09 26.387 36.0391 26.3093 36.0391 26.2187C36.0392 26.0866 36.1462 25.9797 36.2783 25.9795C36.4106 25.9795 36.5184 26.0865 36.5186 26.2187C36.5186 26.3511 36.4107 26.459 36.2783 26.459C36.2704 26.459 36.2626 26.4568 36.2549 26.4561L36.5215 26.8076L36.9961 26.5117C36.9739 26.4754 36.9609 26.4324 36.9609 26.3867C36.9612 26.2547 37.0682 26.1476 37.2002 26.1475C37.3324 26.1475 37.4402 26.2546 37.4404 26.3867C37.4404 26.5191 37.3325 26.627 37.2002 26.627C37.1337 26.6269 37.0736 26.5995 37.0303 26.5557L36.7793 26.9658C36.7576 27.2549 36.7166 27.8426 36.7266 27.8799C36.7338 27.9171 34.9498 27.8954 34.0557 27.8799L33.9297 26.9658L33.6689 26.5996C33.6361 26.6165 33.599 26.627 33.5596 26.627C33.4274 26.6268 33.3203 26.5189 33.3203 26.3867C33.3206 26.2547 33.4276 26.1476 33.5596 26.1475C33.6917 26.1475 33.7995 26.2546 33.7998 26.3867C33.7998 26.4458 33.7767 26.4992 33.7412 26.541L34.2666 26.8076L34.4805 26.458C34.3487 26.4573 34.2422 26.3506 34.2422 26.2187C34.2423 26.0866 34.3494 25.9797 34.4814 25.9795C34.6137 25.9795 34.7216 26.0865 34.7217 26.2187C34.7217 26.3167 34.6623 26.4003 34.5781 26.4375L34.9688 26.6963L35.3047 26.1377C35.1615 26.104 35.0547 25.9767 35.0547 25.8232C35.0548 25.6442 35.1999 25.499 35.3789 25.499Z",
    fill: "#ECC968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2846 27.8151C39.1371 27.6468 38.7555 27.3103 38.4096 27.3103C37.9772 27.3103 37.4825 27.5565 37.5837 27.8151C37.6849 28.0737 38.5051 27.7069 39.087 26.9381C39.4858 26.4112 41.3805 26.771 41.3805 27.3103C41.3805 27.6705 40.6835 27.7724 40.245 27.3103C39.8065 26.8482 40.8027 26.2509 41.4575 26.5479C42.2347 26.9005 42.1314 27.9844 41.1196 27.9844C40.1077 27.9844 39.3681 26.8257 38.5586 26.8482C37.911 26.8662 37.4268 27.1638 37.2656 27.3103",
    stroke: "#ECC968",
    strokeWidth: 0.15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4654 27.8151C31.6129 27.6468 31.9945 27.3103 32.3404 27.3103C32.7728 27.3103 33.2675 27.5565 33.1663 27.8151C33.0651 28.0737 32.2449 27.7069 31.663 26.9381C31.2642 26.4112 29.3695 26.771 29.3695 27.3103C29.3695 27.6705 30.0665 27.7724 30.505 27.3103C30.9435 26.8482 29.9473 26.2509 29.2925 26.5479C28.5153 26.9005 28.6186 27.9844 29.6304 27.9844C30.6423 27.9844 31.3819 26.8257 32.1914 26.8482C32.839 26.8662 33.3232 27.1638 33.4844 27.3103",
    stroke: "#ECC968",
    strokeWidth: 0.15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0107 28.5791C49.1805 28.9447 49.5332 29.5374 49.5332 29.833C49.5332 30.0495 49.2953 30.3027 48.8721 30.3027C48.4728 30.3026 48.1736 29.851 48.0293 29.6768L47.3447 30.3027L47.2871 29.6768L47.9492 29.0391L48.4727 29.2578C48.5485 29.5475 48.6353 29.8184 48.7637 29.7715C48.9063 29.7192 48.9219 29.5078 48.6514 29.0137H46.9209L46.7383 28.5791H49.0107ZM24.1895 27.5576L23.9648 28.0244L22.9795 27.4189L23.7744 28.543H22.4961L23.4502 29.1133L23.2236 29.5967L21.375 28.543L21.7334 27.9209L22.874 28.0244L22.167 26.9697L22.6162 26.3477L24.1895 27.5576ZM48.8721 28.1914H48.2695L47.7842 27.2666L47.1514 27.3721L47.584 27.501L47.9355 28.0742L47.3447 27.9287L46.9697 27.3721L46.624 27.4072C46.7935 27.6917 47.1365 28.2673 47.1514 28.2969C47.1654 28.325 46.8055 28.3086 46.624 28.2969L45.916 27.0908L48.0293 26.7578L48.8721 28.1914ZM23.8916 24.6777C25.1645 25.892 25.2123 26.3179 24.8379 26.79C24.3833 27.3631 23.8428 27.1979 22.7578 26.1406L23.0771 25.7334C23.8919 26.451 24.1616 26.6862 24.3828 26.4512C24.6012 26.2191 24.5217 26.1419 23.4902 25.1416L23.4502 25.1035L23.8916 24.6777ZM47.6641 26.1504C47.8443 26.5841 47.1513 26.7109 46.543 26.7109C45.715 26.7109 45.5277 26.5316 45.165 26.1846L44.8613 25.7959L46.8887 25.0986L47.6641 26.1504ZM45.6357 25.9395C46.0527 26.3817 46.6335 26.3986 46.8926 26.2803C47.056 26.2056 46.8853 25.7603 46.7295 25.5762L45.6357 25.9395ZM25.3955 25.2568L25.9385 24.6777L26.1543 25.1816L25.3955 26.0449L24.0449 24.4883L24.3828 24.0947L25.3955 25.2568ZM46.1895 24.3066L44.7246 25.709L44.3896 25.4189L45.3809 24.4736L44.3896 24.626L44.7246 25.0068L44.084 25.0986L43.3594 24.4736L45.7617 23.9551L46.1895 24.3066ZM26.2422 23.1377L25.9385 23.4346L26.8008 24.6055L26.4404 24.9121L25.5762 23.75L25.1436 24.1553L25.0264 23.6152L26.1543 22.6465L26.2422 23.1377ZM27.6885 22.2002L27.3359 22.4668L27.7822 23.3271L28.252 23.0225V23.5547L27.2031 24.3447L27.0781 23.8125L27.4141 23.5547L26.9053 22.6855L26.4404 23.0225V22.4121L27.6885 21.7148V22.2002ZM45.1445 23.4297L44.5205 23.5283L43.8193 22.9258L43.3594 23.2764H43.6992L44.1914 23.5283L43.5674 23.7256L43.1729 23.4297L42.9648 23.5283L43.6992 24.0869L43.1729 24.3066L42.1211 23.6494L43.8193 22.3711L45.1445 23.4297ZM42.8223 21.8857L41.6719 22.8057L42.3408 23.167L41.8145 23.4297L40.8945 22.9258L42.3408 21.5674L42.8223 21.8857ZM30.9141 22.4121L30.5547 22.5352L30.3477 21.5107L30.0645 22.7305L29.2578 21.8486L29.5635 22.8184L29.1162 23.0225L28.5391 21.292L29.2031 21.0195L29.8789 21.8486L30.0645 20.7256L30.7402 20.4639L30.9141 22.4121ZM40.4902 20.8115L40.1807 21.8047L40.9922 20.9287L41.4521 21.1748L40.0527 22.6699L39.54 22.3711L39.8066 21.3506L39.123 22.2422L38.6748 22.1143L39.8066 20.6279L40.4902 20.8115ZM32.2559 20.5635L31.8955 20.6455V21.5977L32.3516 21.5107L32.3037 21.9512L31.1133 22.332V21.8486L31.5283 21.6855V20.7256L30.998 20.9033L31.0771 20.4639L32.4326 20.0732L32.2559 20.5635ZM37.5049 20.6279C37.869 20.1793 38.3129 20.0575 38.8047 20.3115C39.2661 20.55 39.2956 21.0038 38.915 21.4795C38.5094 21.9864 38.0631 22.1553 37.6338 21.9863C36.985 21.7307 37.1409 21.0764 37.5049 20.6279ZM33.1221 21.3789H33.8467L33.7305 21.8164L32.6309 21.9043L32.6699 20.0732L33.1807 20.0391L33.1221 21.3789ZM34.5771 21.2432H35.3291L35.0977 21.7012L34.0742 21.7354L34.2891 19.9609H34.792L34.5771 21.2432ZM37.6338 20.0039L37.3291 20.4189H36.8359L36.548 21.3164H36.9778L36.7043 21.7354L35.4248 21.7012L35.6738 21.3164H36.0469L36.3594 20.3945H35.8555L36.1875 19.9688L37.6338 20.0039ZM38.54 20.6807C38.3479 20.563 38.078 20.5999 37.9102 20.8125C37.7423 21.0251 37.5996 21.3729 37.7441 21.4697C38.0096 21.6476 38.2784 21.6218 38.4775 21.373C38.6057 21.2129 38.7833 20.8299 38.54 20.6807Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12033_94163",
    x: 16.0781,
    y: 14.173,
    width: 38.6219,
    height: 40.0491,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.623529 0 0 0 0 0.435294 0 0 0 0 0.196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12033_94163"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12033_94163",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_12033_94163",
    x: 11.4219,
    y: 11.1491,
    width: 47.4969,
    height: 46.469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.623529 0 0 0 0 0.435294 0 0 0 0 0.196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12033_94163"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12033_94163",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_12033_94163",
    x: 30.875,
    y: 6.91849,
    width: 8.26562,
    height: 10.3926,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12033_94163"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12033_94163",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12033_94163",
    x1: 35.3347,
    y1: 7.36279,
    x2: 35.3347,
    y2: 62.6372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF9E33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538462,
    stopColor: "#ECCB66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9AE48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12033_94163",
    x1: 11.1126,
    y1: 42.2863,
    x2: 28.8634,
    y2: 51.6588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF9E33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ECCB66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9AE48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12033_94163",
    x1: 23.5064,
    y1: 2.58246,
    x2: 23.5064,
    y2: 35.0314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538462,
    stopColor: "#A31F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A31F21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12033_94163",
    x1: 23.5064,
    y1: 2.58246,
    x2: 23.5064,
    y2: 35.0314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD9C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BD62"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_12033_94163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.6305 10.4542) rotate(90) scale(0.833633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3A435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BE55"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_12033_94163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.4039 1.27727) rotate(90) scale(0.833633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3A435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BE55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12033_94163",
    x1: 23.5064,
    y1: 67.3328,
    x2: 23.5064,
    y2: 34.8839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538462,
    stopColor: "#A31F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A31F21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12033_94163",
    x1: 23.5064,
    y1: 67.3328,
    x2: 23.5064,
    y2: 34.8839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD9C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BD62"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_12033_94163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.833633 0.833633) rotate(90) scale(0.833633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3A435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BE55"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_12033_94163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.833633 0.833633) rotate(90) scale(0.833633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3A435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BE55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12033_94163",
    x1: 57.4368,
    y1: 8.41713,
    x2: 29.3352,
    y2: 24.6416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538462,
    stopColor: "#A31F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A31F21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12033_94163",
    x1: 57.4368,
    y1: 8.41713,
    x2: 29.3352,
    y2: 24.6416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD9C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BD62"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_12033_94163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.1792 1.20212) rotate(90) scale(0.833633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3A435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BE55"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_12033_94163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0152 10.2738) rotate(90) scale(0.833633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3A435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BE55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_12033_94163",
    x1: 57.4368,
    y1: 61.4981,
    x2: 29.3352,
    y2: 45.2736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538462,
    stopColor: "#A31F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A31F21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_12033_94163",
    x1: 57.4368,
    y1: 61.4981,
    x2: 29.3352,
    y2: 45.2736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD9C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BD62"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_12033_94163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.833633 0.833633) rotate(90) scale(0.833633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3A435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BE55"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_12033_94163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.833633 0.833633) rotate(90) scale(0.833633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3A435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BE55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_12033_94163",
    x1: 68.9616,
    y1: 29.2183,
    x2: 40.86,
    y2: 45.4428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538462,
    stopColor: "#A31F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A31F21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_12033_94163",
    x1: 68.9616,
    y1: 29.2183,
    x2: 40.86,
    y2: 45.4428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD9C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BD62"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_12033_94163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.833633 0.833633) rotate(90) scale(0.833633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3A435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BE55"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_12033_94163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.833633 0.833633) rotate(90) scale(0.833633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3A435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BE55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_12033_94163",
    x1: 1.38212,
    y1: 40.8694,
    x2: 29.4837,
    y2: 24.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538462,
    stopColor: "#A31F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A31F21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_12033_94163",
    x1: 1.38212,
    y1: 40.8694,
    x2: 29.4837,
    y2: 24.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD9C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BD62"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_12033_94163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.833633 0.833633) rotate(90) scale(0.833633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3A435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BE55"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_12033_94163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.833633 0.833633) rotate(90) scale(0.833633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3A435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4BE55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_12033_94163",
    x1: 26.3196,
    y1: 11.8715,
    x2: 49.2827,
    y2: 55.3215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C49239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#FBEF98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C18D33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_12033_94163",
    x1: 35.0047,
    y1: 13.4371,
    x2: 35.0047,
    y2: 55.3215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6953B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509615,
    stopColor: "#FBF099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08C32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_12033_94163",
    x1: 50.5397,
    y1: 28.9601,
    x2: 21.7937,
    y2: 39.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3C164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#C49136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA9B41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_12033_94163",
    x1: 35.0099,
    y1: 16.8772,
    x2: 35.0099,
    y2: 51.8814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECCD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#E0BE5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E38A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_12033_94163",
    x1: 35.0099,
    y1: 16.8772,
    x2: 35.0099,
    y2: 51.8814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#977537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423077,
    stopColor: "#B68E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7E78F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_12033_94163",
    x1: 38.119,
    y1: 14.173,
    x2: 32.3955,
    y2: 53.9922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA86F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323409,
    stopColor: "#FAF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392349,
    stopColor: "#885621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735577,
    stopColor: "#F7D272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8953A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_12033_94163",
    x1: 39.8851,
    y1: 10.7566,
    x2: 30.4608,
    y2: 57.8077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA86F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323409,
    stopColor: "#FAF8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392349,
    stopColor: "#885621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735577,
    stopColor: "#F7D272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8953A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_12033_94163",
    x1: 34.7578,
    y1: 7.66849,
    x2: 34.7578,
    y2: 16.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EBB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#F5CF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C07A42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_12033_94163",
    x1: 34.7583,
    y1: 8.34564,
    x2: 34.7583,
    y2: 15.3837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#F5D057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A96E3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_12033_94163",
    x1: 34.7603,
    y1: 8.57449,
    x2: 34.7603,
    y2: 15.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D0816"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_12033_94163",
    x1: 34.314,
    y1: 10.0353,
    x2: 34.314,
    y2: 11.2262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0D393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C17D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F9D981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC8740"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_12033_94163",
    x1: 33.7642,
    y1: 10.8392,
    x2: 33.7642,
    y2: 13.4062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0D393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C17D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F9D981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC8740"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_12033_94163",
    x1: 35.1649,
    y1: 10.2228,
    x2: 35.1649,
    y2: 13.4371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0D393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C17D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F9D981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC8740"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_12033_94163",
    x1: 35.7666,
    y1: 10.8506,
    x2: 35.7666,
    y2: 13.4304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0D393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C17D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F9D981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC8740"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_12033_94163",
    x1: 45.9656,
    y1: 33.7332,
    x2: 23.4061,
    y2: 38.7233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117521,
    stopColor: "#FAE783"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275128,
    stopColor: "#C78018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FBE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#C88330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5BD9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_12033_94163",
    x1: 36.3421,
    y1: 40.1107,
    x2: 36.3421,
    y2: 41.6382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C78018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FBE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#C88330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5BD9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_12033_94163",
    x1: 31.7434,
    y1: 40.067,
    x2: 31.7434,
    y2: 41.6349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C78018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FBE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#C88330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5BD9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_12033_94163",
    x1: 42.1184,
    y1: 40.067,
    x2: 42.1184,
    y2: 41.6349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C78018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FBE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#C88330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5BD9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_12033_94163",
    x1: 44.0794,
    y1: 40.067,
    x2: 44.0794,
    y2: 41.6349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C78018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FBE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#C88330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5BD9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_12033_94163",
    x1: 25.8816,
    y1: 40.0445,
    x2: 25.8816,
    y2: 41.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C78018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FBE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#C88330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5BD9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_12033_94163",
    x1: 27.63,
    y1: 40.0445,
    x2: 27.63,
    y2: 41.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C78018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FBE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#C88330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5BD9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_12033_94163",
    x1: 29.5959,
    y1: 40.0564,
    x2: 29.5959,
    y2: 41.6404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C78018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FBE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#C88330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5BD9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_12033_94163",
    x1: 33.7946,
    y1: 40.0445,
    x2: 33.7946,
    y2: 41.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C78018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FBE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#C88330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5BD9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_12033_94163",
    x1: 39.696,
    y1: 40.067,
    x2: 39.696,
    y2: 41.6349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C78018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FBE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#C88330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5BD9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_12033_94163",
    x1: 37.8162,
    y1: 40.0868,
    x2: 37.8162,
    y2: 41.6457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#C78018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FBE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#C88330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5BD9C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12033_94163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeMml2026);
export default __webpack_public_path__ + "static/media/badge-mml2026.bf30083348e12d0aac56eb12af877055.svg";
export { ForwardRef as ReactComponent };